import { Badge, Fab, makeStyles, Popper } from "@material-ui/core";
import { Chat as ChatIcon, Close as CloseIcon } from "@material-ui/icons";
import { useFeatures } from "@paralleldrive/react-feature-toggles";
import React, { useState } from "react";
import ChatApp from "./ChatApp";

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chatButton: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(3)
  },
  chatPopover: {
    width: 1024,
    height: 520,
    zIndex: 1,
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      width: 800,
      height: 480
    }
  }
}));

const ChatWidget = () => {
  const features = useFeatures();

  /* Chat component */

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const [totalUnreadCount, setTotalUnreadCount] = useState(0);

  const toggleChat = event => {
    setAnchorEl(anchorEl === null ? event.currentTarget : null);
  };

  const onUnreadCountChange = ({ unreadCount }) => {
    setTotalUnreadCount(unreadCount);
  };

  if (!features.includes("chat")) {
    return null;
  }
  return (
    <div className={classes.root}>
      <Fab
        color="primary"
        aria-label="open-chat"
        className={classes.chatButton}
        onClick={toggleChat}
      >
        <Badge badgeContent={totalUnreadCount} color="secondary">
          {anchorEl ? <CloseIcon /> : <ChatIcon />}
        </Badge>
      </Fab>
      <Popper
        className={classes.chatPopover}
        open={!!anchorEl}
        anchorEl={anchorEl}
        placement="top-end"
        disablePortal={false}
        keepMounted
        modifiers={{
          flip: {
            enabled: false
          },
          preventOverflow: {
            enabled: false,
            boundariesElement: "scrollParent"
          },
          arrow: {
            enabled: true,
            element: anchorEl
          }
        }}
      >
        <ChatApp open={Boolean(anchorEl)} onUnreadCountChange={onUnreadCountChange} />
      </Popper>
    </div>
  );
};

export default ChatWidget;
